module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 2-d3e958c82a065c0f7cf3a21ce5d469fb.jpg";